import * as Yup from "yup";

import { FORM_ERROR_MESSAGES, IS_EXIST_DIGIT, IS_EXIST_LOWERCASE, IS_EXIST_UPPERCASE } from "../constants";

export const emailValidator = Yup.string()
  .required(`This ${FORM_ERROR_MESSAGES.REQUIRED}`)
  .trim()
  .email(FORM_ERROR_MESSAGES.EMAIL)
  .max(150, `Email ${FORM_ERROR_MESSAGES.LONG}`)
  .test("valid-tld", FORM_ERROR_MESSAGES.EMAIL, (value) => {
    if (!value) return false;

    const tld = value.split(".").pop();

    return Boolean(tld && tld.length >= 2);
  });

export const passwordValidator = Yup.string()
  .required(FORM_ERROR_MESSAGES.REQUIRED)
  .trim()
  .min(6, `Password ${FORM_ERROR_MESSAGES.SHORT}`)
  .matches(IS_EXIST_DIGIT, FORM_ERROR_MESSAGES.DIGIT)
  .matches(IS_EXIST_LOWERCASE, FORM_ERROR_MESSAGES.LOWERCASE)
  .matches(IS_EXIST_UPPERCASE, FORM_ERROR_MESSAGES.UPPERCASE);

export const stringValidator = Yup.string().trim(FORM_ERROR_MESSAGES.TRIM).strict(true);

/**
 * Validates and transforms values using a Yup schema,
 * returning trimmed/cleaned results.
 */
export const getTrimmedValues = async <T extends Yup.AnyObjectSchema>(
  schema: T,
  values: unknown,
): Promise<Yup.InferType<T>> => {
  return await schema.validate(values, {
    abortEarly: false,
    stripUnknown: true,
  });
};
